"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveAs = void 0;

/**
 * @namespace skybase-core.services.filesave
 */

/**
 * @description
 * If you have an text, you want to save into file, you can use this function.
 *
 * @namespace skybase-core.services.filesave#saveAs
 * @Function
 *
 * @param  {String} filename the name of the file
 * @param  {String} data you want to save.
 * @param  {Object} options - options which are used for creating and Blob object
 */
var saveAs = function saveAs(filename, data) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    type: 'text/txt'
  };
  var blob = new Blob([data], options);

  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    var elem = window.document.createElement('a');
    elem.href = window.URL.createObjectURL(blob);
    elem.download = filename;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
  }
};

exports.saveAs = saveAs;
//# sourceMappingURL=file-save.js.map